import * as React from 'react';
import { Modal, Typography, Card, Box, Grid, IconButton, Icon, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CancelIcon from '../../../icons/cancelIcon.svg';
import ConfirmationTick from '../../../icons/ConfirmationTick.svg';

const useStyles = makeStyles({
  modalContainer: {
    background: '#FFFFFF',
    boxShadow: 'none',
    borderRadius: '24px',
  },
  titleText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
    textAlign: 'center',
  },
  detailsText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    color: '#000000 !important',
  },
  buttonContainer: {
    position: 'absolute',
    bottom: '20px',
    marginLeft: 'calc( 50% - 100px )',
  },
});

interface ConfirmModalProps {
  open: boolean;
  title: string;
  isInvisible?: boolean;
  closeCallback: () => void;
  confirmCallback: () => void;
}

export default function ConfirmModal(props: ConfirmModalProps) {
  const classes = useStyles();
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    minHeight: '523px',
    pointerEvents: 'auto',
    width: '98%',
    maxWidth: '472px',
    borderRadius: '24px',
    outline: 'none',
  };

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={() => props.closeCallback()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: props.isInvisible ?? false,
        }}
      >
        <Card sx={style}>
          <Grid container>
            <Grid item xs={2}></Grid>
            <Grid item xs={8}>
              <Typography className={classes.titleText} sx={{ mt: 1 }}>
                {props.title}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton sx={{ ml: '30px' }} onClick={() => props.closeCallback()}>
                <Icon>
                  <img src={CancelIcon} alt="" width={24} height={24} />
                </Icon>
              </IconButton>
            </Grid>
          </Grid>

          <Box>
            <Grid item display="flex" justifyContent="center" pb={3} pt={5}>
              <img src={ConfirmationTick} alt="confirmation" />
            </Grid>

            <Box sx={{ textAlign: 'center', mt: 5, px: 5 }}>
              <Typography className={classes.detailsText} sx={{ fontWeight: '300 !important', color: '#14142B !important' }}>
                Are you sure you want to proceed?
              </Typography>
            </Box>

            <div className={classes.buttonContainer}>
              <Button
                variant="contained"
                style={{
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  width: '87px',
                  background: '#A2DBFA',
                  borderRadius: '24px',
                  textTransform: 'capitalize',
                }}
                onClick={() => props.confirmCallback()}
              >
                Yes
              </Button>
              <Button
                variant="contained"
                style={{
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  width: '87px',
                  marginLeft: '8px',
                  background: '#39A2DB',
                  borderRadius: '24px',
                  textTransform: 'capitalize',
                }}
                onClick={() => props.closeCallback()}
              >
                No
              </Button>
            </div>
          </Box>
        </Card>
      </Modal>
    </div>
  );
}
